import React from 'react';
import styled from 'styled-components';
import { useLanguage } from '../contexts/LanguageContext';

const SwitcherContainer = styled.div`
  position: absolute;
  right: 2%; /* Match the 2% margin from home background image */
  display: flex;
  align-items: center;
  gap: 0.5rem;
  
  @media (max-width: 992px) {
    position: relative;
    right: auto;
    padding: 0.5rem;
  }
`;

const ToggleContainer = styled.div`
  display: flex;
  background-color: #f5f5f5;
  border-radius: 5px;
  padding: 1px;
  gap: 0;
`;

const LanguageButton = styled.button`
  background: ${({ active }) => (active ? '#000000' : 'transparent')};
  border: none;
  color: ${({ active }) => (active ? '#ffffff' : '#666666')};
  font-weight: 500;
  font-size: 0.6rem;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  font-family: 'Montserrat', sans-serif;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 0.3rem 0.6rem;
  border-radius: 4px;
  min-width: 24px;
  
  &:hover {
    background: ${({ active }) => (active ? '#000000' : '#e5e5e5')};
    color: ${({ active }) => (active ? '#ffffff' : '#333333')};
  }
`;

const LanguageSwitcher = () => {
  const { language, switchLanguage } = useLanguage();
  
  return (
    <SwitcherContainer>
      <ToggleContainer>
        <LanguageButton 
          active={language === 'de'}
          onClick={() => switchLanguage('de')}
        >
          DE
        </LanguageButton>
        <LanguageButton 
          active={language === 'en'}
          onClick={() => switchLanguage('en')}
        >
          EN
        </LanguageButton>
      </ToggleContainer>
    </SwitcherContainer>
  );
};

export default LanguageSwitcher; 